//process data from product configurations

import {DOMAIN_TYPE, EMAIL_HOSTING_TYPE, SHARED_HOSTING_TYPE} from "./servicetype"
import {AUTO_RENEW, EPP_CODE, ID_PROTECTION} from "../../components/shared/steps/selectdomainconfig"
import {generateProductPayloadConfig} from "./manageServiceTypes"
import {getSlugByName} from "./common"
import {getCartToken} from "./cartToken"
import {getPriceByBillingCycleID} from "./billingCycle"

export const getOrderingFlowType = (id) => {
    let flowType = undefined
    if (window && window.app_config && window.app_config.product_flow
        && Object.keys(window.app_config.product_flow)) {
        const product_flow = window.app_config.product_flow
        const keys = Object.keys(product_flow)
        keys.forEach(key => {
            if (product_flow[key]) {
                var string = product_flow[key].split(',')
                string.forEach(pid => {
                    if (parseInt(id) === parseInt(pid.trim())) {
                        flowType = key
                    }
                })
            }
        })
    }
    return flowType
}

export const getFilteredConfigurationList = (type, configurations, added = false, upsell = false,forPayload=false) => {
    let list = []
    const newConfigurations = Object.assign({},configurations)
    Object.keys(newConfigurations).forEach((key) => {
        if (newConfigurations[key] && getAttributes(newConfigurations[key].selectedProduct)) {
            const {service_type} = getAttributes(newConfigurations[key].selectedProduct)
            //filter based on
            if (service_type && newConfigurations[key].selectedProduct.attributes.service_type === type) {
                let selected = null
                if (added) {
                    if (added === true) {
                        if (newConfigurations[key].uuid) {
                            //list.push(newConfigurations[key])
                            selected = newConfigurations[key]
                        }
                    } else {
                        if (added === 'all') {
                            //list.push(newConfigurations[key])
                            selected = newConfigurations[key]
                        }
                    }
                } else {
                    if (!newConfigurations[key].uuid) {
                        if (upsell) {
                            if (newConfigurations[key].upsell) {
                                //list.push(newConfigurations[key])
                                selected = newConfigurations[key]
                            }
                        } else {
                            if (type === DOMAIN_TYPE) {
                                if (newConfigurations[key].domainSearchResult) {
                                    //list.push(newConfigurations[key])
                                    selected = newConfigurations[key]
                                }
                            } else {
                                //list.push(newConfigurations[key])
                                selected = newConfigurations[key]
                            }
                        }
                    }
                }
                if(selected){
                    if(forPayload){
                        delete selected['selectedProduct']
                        delete selected['breadcrumbs']
                        delete selected['domainSearchResult']
                        delete selected['step']
                        delete selected['upsell']
                    }
                    list.push(selected)
                }
            }
        }
    })

    return list
}

export const getProductLabel = (name, productType) => {
    //get custom product label
    if (productType === SHARED_HOSTING_TYPE && name.indexOf('Hosting') === -1) {
        return name + ' Shared Hosting'
    }
    if (productType === EMAIL_HOSTING_TYPE) {
        return name + ' Email Hosting'
    }
    return name
}

export const getAppConfigValue = (key) => {
    if (window && window.app_config) {
        return window.app_config[key]
    }
    return null
}

export const isLastStep = (breadcrumbs, currentStep) => {
    const last = (breadcrumbs && breadcrumbs.length > 0) ? breadcrumbs.length - 1 : null
    if (last && last === currentStep) {
        return true
    }
    return false
}

export const getServiceTypeFromProductConfig = (productConfig) => {
    //return service type from product configuration
    if (productConfig && productConfig.selectedProduct && productConfig.selectedProduct.attributes) {
        const { service_type } = productConfig.selectedProduct.attributes
        return service_type
    }
    return null
}

export const getAttributes = (item) => {
    //get attributes property
    if (item && item.attributes) {
        return item.attributes
    }
    return item
}

export const hasAddonInProductConfiguration = (productConfiguration) => {
    //check if this product has addon
    let hasAddon = false
    if (productConfiguration && Object.keys(productConfiguration).length > 0) {
        Object.keys(productConfiguration).forEach(key => {
            if (key === 'addons' && productConfiguration[key] && productConfiguration[key].length > 0) {
                hasAddon = true
            }
        })
    }
    return hasAddon
}

export const isConfigurationAdded = (productConfig)=>{
    //check if this product has been added to the cart
    return productConfig && productConfig.uuid
}

export const getDomainNamePayloadFromConfig = (config) => {
    //get payload for adding domain name endpoint
    let domainProduct = null
    if (config) {
        const {
            domainSearchResult,
            selectedProduct,
            order_type,
            custom_fields,
            billing_cycle_id,
            epp,
            auto_renew,
            id_protection
        } = config || {}
        const getProductID = () => {
            if (selectedProduct && selectedProduct.id) {
                return selectedProduct.id
            }
            return null
        }
        const getDomainName = () => {
            if (domainSearchResult) {
                const { domain, tld } = domainSearchResult
                return domain + tld
            } else {
                const { name } = config
                return name
            }
        }
        const id_protection_slug = getSlugByName(ID_PROTECTION)
        const epp_slug = getSlugByName(EPP_CODE)
        const auto_renew_slug = getSlugByName(AUTO_RENEW)
        domainProduct = {
            order_type,
            custom_fields,
            billing_cycle_id,
            id: getProductID(),
            name: getDomainName()
        }

        // Domain Product
        if (epp && order_type === 'transfer'){
            config.epp = epp
        }
        if (id_protection != null){
            config.id_protection = id_protection
        }
        if (auto_renew != null){
            config.auto_renew = auto_renew
        }

        if (auto_renew_slug && config[auto_renew_slug] != null) {
            domainProduct[auto_renew_slug] = config[auto_renew_slug]
        }

        if (epp_slug && config[epp_slug]) {
            domainProduct[epp_slug] = config[epp_slug]
        }

        if (id_protection_slug && config[id_protection_slug] != null) {
            domainProduct[id_protection_slug] = config[id_protection_slug]
        }

    }
    return domainProduct
}

export const generatePayloadFromConfig = (productConfig, configurations) => {
    //generate payload for adding products endpoints
    if (productConfig && Array.isArray(productConfig) && productConfig.length > 0) {
        return productConfig.map(config => {
            const { selectedProduct } = config
            if (selectedProduct && selectedProduct.attributes) {
                const { service_type } = selectedProduct.attributes
                if (service_type === DOMAIN_TYPE) {
                    return (getDomainNamePayloadFromConfig(config))
                }
            }
            return (config)
        })
    }
    return (generateProductPayloadConfig(productConfig, configurations))
}

export const getUpdateProductConfigPayload = (productConfig, cartData, uuid) => {
    //generate payload for updating end point
    let payload = {}
    if (cartData && cartData.items && cartData.items.length > 0) {
        const { selectedProduct, billing_cycle_id, name, addons, config, quantity } = productConfig
        const { id } = selectedProduct
        const selectedCartItem = cartData.items.find(item => item.uuid === uuid)
        const { discount_type, discount } = selectedCartItem
        let updatedAddons = []
        if (addons && addons.length) {
            updatedAddons = addons.filter(item => item.id !== 'auto-ssl')
            updatedAddons = updatedAddons.map(item => ({
                id: item.id,
                billing_cycle_id
            }))
        }

        let items = {
            id,
            billing_cycle_id
        }
        if (name) {
            items = {
                ...items,
                name
            }
        }
        if (quantity) {
            items = {
                ...items,
                quantity
            }

        }
        if (discount_type && discount) {
            items = {
                ...items,
                discount_type,
                discount
            }
        }
        if (config && config.length) {
            items = {
                ...items,
                config
            }
        }
        if (updatedAddons && updatedAddons.length) {
            items = {
                ...items,
                addons: updatedAddons
            }
        }
        payload = {
            token: getCartToken(),
            uuid,
            items
        }
    }
    return payload
}

export const getPurchasedDomainFromProductConfig = (productConfig, configurations) => {
    //get domain name config from hosting product config
    const domainNameList = getFilteredConfigurationList(DOMAIN_TYPE, configurations, false, false)
    let purchasedDomain = null
    if (domainNameList && Array.isArray(domainNameList) && domainNameList.length > 0) {
        domainNameList.forEach(d => {
            if (d.domainSearchResult) {
                const { domain, tld } = d.domainSearchResult
                if (domain + tld === productConfig['name']) {
                    purchasedDomain = d
                }
            }
        })
    }
    return purchasedDomain
}

export const getPurchasedDomainPrice = purchasedDomainConfig => {
    //get selected price in the hosting product configurations
    if (purchasedDomainConfig &&
        purchasedDomainConfig.selectedProduct &&
        purchasedDomainConfig.order_type &&
        purchasedDomainConfig.billing_cycle_id &&
        getAttributes(purchasedDomainConfig.selectedProduct)) {
        const { billing_cycle_id, order_type} = purchasedDomainConfig
        const price = getPurchaseDomainNamePriceList(purchasedDomainConfig)
        const selectedPrice = getPriceByBillingCycleID(price, billing_cycle_id, order_type)
        if (selectedPrice && selectedPrice.type && selectedPrice.price) {
            return selectedPrice
        }
    }
    return null
}

export const getPurchaseDomainNamePriceList = (purchasedDomainConfig) =>{
    //get selected price in the domain product configurations
    let priceList = []
    if (purchasedDomainConfig &&
        purchasedDomainConfig.selectedProduct &&
        purchasedDomainConfig.order_type &&
        purchasedDomainConfig.billing_cycle_id &&
        getAttributes(purchasedDomainConfig.selectedProduct)) {
        const { billing_cycle_id, order_type,is_premium,total_amount } = purchasedDomainConfig
        let { price } = getAttributes(purchasedDomainConfig.selectedProduct)
        if (purchasedDomainConfig.domainSearchResult) {
            const {premium} = purchasedDomainConfig.domainSearchResult
            if (premium) {
                priceList = purchasedDomainConfig.domainSearchResult.price
            } else {
                priceList = price
            }
        } else {
            let premiumPrice = getPriceByBillingCycleID(price, billing_cycle_id, order_type)
            if (premiumPrice && premiumPrice.type && premiumPrice.price && is_premium && total_amount) {
                premiumPrice.price = total_amount
                priceList = [premiumPrice]
            }else{
                priceList = price
            }
        }
    }
    return priceList
}

export const isFirstInvoicePromo = (productConfig) =>{
    let isThePromo = false
    if(productConfig && getAttributes(productConfig.selectedProduct)){
        const {discount_price} = getAttributes(productConfig.selectedProduct)
        if(discount_price && discount_price.length && Array.isArray(discount_price)){
            discount_price.forEach(item=>{
                if(!item.is_recurring){
                    isThePromo = true
                }
            })
        }
    }
    return isThePromo
}

export const isPremiumDomain = (productConfig) =>{
    let flag = false
    if(productConfig){
        if(productConfig.uuid){
            const {is_premium} = productConfig
            flag = is_premium
        }else{
            if(productConfig.domainSearchResult){
                const {premium} = productConfig.domainSearchResult
                flag = premium
            }
        }
    }
    return flag
}

export const getGroupName = (group) => {
    if (group && group.name) {
        let text = group.name
        if (text && text.indexOf('Smarter') > -1) {
            text = text.replace('Smarter', '')
        }
        return text
    }
    return undefined
}

export const getDomainNameCID = (domainConfig, forForm = false) => {
    //get domain configuration id
    const { uuid } = domainConfig
    if (uuid) {
        return uuid
    }
    if (domainConfig && domainConfig.domainSearchResult) {
        const { domain, tld } = domainConfig.domainSearchResult
        if (domain && tld) {
            if (forForm) {
                return (escape(domain + tld).replace('.', '_'))
            }
            return (escape(domain + tld))
        }
    }
    return null
}

export const getDomainNameFromProductConfig = (config) => {
    if(config && config.domainSearchResult){
        const {domain,tld } = config.domainSearchResult
        return domain + tld
    }
    const {name} = config
    return name
}

export const getAddonFromProductConfig = (productConfig,addonID) =>{
    if(productConfig && getAttributes(productConfig.selectedProduct)){
        const {addons} = getAttributes(productConfig.selectedProduct)
        if(addons && addons.length){
            return addons.find(item=>item.id===addonID)
        }
    }
    return null
}